<script>
export default {
  name: 'PageTitle',
  props: {
    bigTitle: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    subTitle: {
      type: String,
      default: '',
    },
    numberTitle: {
      type: Number,
      default: null,
    },
    bgImage: {
      type: String,
      default: '',
    },
    bgPosition: {
      type: String,
      default: 'center',
    },
    content: {
      type: Array,
      default: () => [],
    },
  },
}
</script>

<template>
  <div class="home-guide">
    <div
      class="guide-content"
      :style="
        `background-image: url('${bgImage}');background-position: ${bgPosition};`
      "
    >
      <h2 class="guide-title">
        {{ title }}<span class="guide-number">{{ numberTitle }}</span>
      </h2>
      <h3 class="guide-sub-title">{{ subTitle }}</h3>
      <template v-for="(item, idx) of content">
        <div
          class="guide-col-container guide-container"
          :class="item.class"
          v-if="item.type === 'col'"
          :key="`part-${idx}`"
        >
          <div class="col-1" v-if="item.col1.length > 0">
            <template v-for="(colItem, idx) of item.col1">
              <div
                :class="colItem.class"
                v-if="colItem.image"
                :key="`img-${idx}`"
              >
                <img :src="colItem.image" alt="" />
              </div>
              <div
                class="title"
                :class="colItem.class"
                v-if="colItem.title"
                v-html="colItem.title"
                :key="`title-${idx}`"
              ></div>
              <div
                class="text"
                :class="colItem.class"
                v-if="colItem.text"
                v-html="colItem.text"
                :key="`text-${idx}`"
              ></div>
            </template>
          </div>
          <div class="col-2" v-if="item.col2.length > 0">
            <template v-for="(colItem, idx) of item.col2">
              <div
                class="img-container"
                :class="colItem.class"
                v-if="colItem.image"
                :key="`img-${idx}`"
              >
                <img :src="colItem.image" alt="" />
              </div>

              <div
                class="title"
                :class="colItem.class"
                v-if="colItem.title"
                v-html="colItem.title"
                :key="`title-${idx}`"
              ></div>
              <div
                class="text"
                :class="colItem.class"
                v-if="colItem.text"
                v-html="colItem.text"
                :key="`text-${idx}`"
              ></div>
            </template>
          </div>
        </div>
        <div
          class="guide-container-block"
          :class="item.class"
          v-if="item.type === 'text-block'"
          :key="`part-${idx}`"
          v-html="item.text"
        />
      </template>
      <slot />
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import 'home-guide-other-style.scss';
</style>
